import { FooterRight2, FooterLeft2, FooterMain2 } from "../../";
import Map from "../../../assets/img/NewsImgs/map.png"; // فرض بر این است که از این تصویر استفاده می‌کنید

const Footer2 = () => {
    return (
        <>
            {/* نمایش برای موبایل */}
            <div className="flex items-center md:block justify-between bg-hero-pattern bg-contain bg-center bg-no-repeat bg-darkGreen2 h-full mt-10 w-[100%] px-[120px]  pt-5 pb-20 xl:px-[20px]">
             
                   <div className="w-[30%] md:w-full ">
                   <FooterRight2 />
                   </div>
                    <div className="w-1/3 md:w-full">
                    <FooterMain2 />
                    </div>
                
                <div className="w-1/3 md:w-full">
                <FooterLeft2 />
                </div>
            </div>

            {/* نمایش برای دسکتاپ */}
           
        </>
    );
};

export default Footer2;
